<template>
    <div class="center-on-page">
        <div class="login-form-con">
            <div class="has-text-centered">
                <div class="image logo" v-if="this.$store.state.dealer_portal.brandLogo">
                    <img :src="$srcOverwrite(this.$store.state.dealer_portal.brandLogo)"/>
                </div>
                <h1 class="title" v-if="!this.$store.state.dealer_portal.brandLogo">{{this.$store.state.dealer_portal.brandName}}</h1>
            </div>
            <form @submit.prevent="login('login')" data-vv-scope="login">

                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('login.email') }" type="email" placeholder="Email" v-model="payload.email" name="email" v-validate="'email|required'"/>
                        <span class="icon is-left">
                            <i class="fa fa-envelope"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('login.email')" class="help is-danger">{{ errors.first('login.email') }}</p>
                </div>

                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('login.password') }" type="password" placeholder="Password" v-model="payload.password" name="password" v-validate="'required'"/>
                        <span class="icon is-left">
                            <i class="fa fa-user-secret"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('login.password')" class="help is-danger">{{ errors.first('login.password') }}</p>
                </div>

                <button class="button is-primary is-block-button" :class="{ 'is-loading' : loading }" type="submit">
                    Login
                </button>

                <div class="notification is-danger has-text-centered" v-show="invalid" style="margin-top:10px;">
                    No account matches those credentials...
                </div>

                <div class="has-text-centered m-v-xs">
                    <a @click="togglePasswordModal">Forgot Password?</a>
                </div>

                <div class="has-text-centered m-v-lg">
                    <router-link :to="{ name : $ROUTES.SIGNUP }" class="button">Signup</router-link>
                </div>

            </form>

        </div>

        <modal :active="show_forgot_password" :close="togglePasswordModal">
            <form  @submit.prevent="forgotPassword('forgot')" data-vv-scope="forgot" v-show="!forgot_done">

                <h1 class="heading has-text-centered">Get a password reset email</h1>

                <hr>

                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('forgot.email') }" type="email" placeholder="Email" v-model="forgot_email" name="email" v-validate="'email|required'"/>
                        <span class="icon is-left">
                    <i class="fa fa-envelope"></i>
                  </span>
                    </div>
                    <p v-show="errors.has('forgot.email')" class="help is-danger">{{ errors.first('forgot.email') }}</p>
                </div>

                <button class="button is-primary is-block-button" :class="{ 'is-loading' : loading_forgot }" type="submit">
                    Email Me
                </button>

            </form>
            <div class="notification is-success" v-show="forgot_done">
                If an account with that email exists it has been emailed a link that will allow the password to be reset.
            </div>
        </modal>

    </div>
</template>

<script>
import UserPublic from '../api/UserPublic'
import SecurityUtil from "../util/SecurityUtil";

export default {
    name : 'login',
    data () {
        return {
            payload : {
                email : '',
                password : '',
            },
            loading : false,
            invalid : false,
            show_forgot_password : false,
            forgot_email : null,
            loading_forgot : false,
            forgot_done : false,
        }
    },
    beforeCreate () {
        if (this.$getDealer()) {
            this.$router.push({ name : this.$ROUTES.DASHBOARD })
        }
    },
    methods : {
        login (scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (!result) {
                    return
                }
                this.loading = true
                UserPublic.login(this.payload).then((response) => {
                    if (!response.data || !response.data.token) {
                        this.invalid = true;
                        this.loading = false;
                        return
                    }
                    this.$store.commit('setSessionContext', response.data);
                    SecurityUtil.setToken(response.data.token);
                    this.$router.push('/')
                }, () => {
                    this.invalid = true;
                    this.loading = false;
                });
            })
        },
        togglePasswordModal () {
            this.show_forgot_password = !this.show_forgot_password
        },
        forgotPassword (scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (!result) {
                    return
                }
                this.loading_forgot = true
                UserPublic.postForgotPassword({ email : this.forgot_email }).then(() => {
                    this.forgot_done = true
                    this.loading_forgot = false
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .login-form-con {
        width:320px;
    }
    .logo {
        margin-bottom:20px;
        img {
            max-height: 130px;
            max-width: 100%;
            width: auto;
            height: auto;
            margin:0 auto;
        }
    }
    .title {
        margin-bottom:20px;
    }
</style>
